import IFilmnytt from "src/lib/types/Filmnytt";
import { getImage, getUrlForDoctype } from "src/lib/types/sanity";
import FilmwebLink from "src/components/filmweblink/FilmwebLink";
import CmsImage from "src/components/images/CmsImage";
import DocumentIcon from "src/components/documenticon/DocumentIcon";
import classNames from "classnames";
import styles from "./OneThirdsImageOnLeft.module.css";

//#region [Props]
type OneThirdsImageOnLeftProps = {
    document: IFilmnytt;
    className?: string;
    isStreamingContext?: boolean;
    useSectionTitle?: boolean;
    //isContentAd?: boolean;
    headerLevel?: 1 | 2 | 3 | 4 | 5 | 6;
    //contentAdLabelPlacementMobile?: "overlay" | "bottom"
    sizes: string;
};
//#endregion

//#region [Component]
export default function OneThirdsImageOnLeft({ document, className, isStreamingContext = false, useSectionTitle = false, headerLevel = 1, sizes }: OneThirdsImageOnLeftProps) {
    const slug = document.slug.current;
    const url = getUrlForDoctype(document._type, slug, document.isStreaming as boolean | undefined || isStreamingContext, document);
    const title = useSectionTitle ? (document.sectionPageTitle as string ?? document.title) : document.title;
    const image = getImage(document);
    const HeadingTag: React.ElementType = `h${headerLevel}`;
    return <article className={classNames(styles.SImageTitle, className)}>
        <FilmwebLink className={styles.SFilmwebLink} to={url!}>
            {image && <CmsImage className={styles.SCmsImage} image={image} alt={image.asset?.altText ?? ""} crop sizes={sizes} />}
            <header className={styles.SHeader}>
                <HeadingTag className={styles.SH}>{title}</HeadingTag>
                <DocumentIcon document={document} />
            </header>
        </FilmwebLink>
    </article>;
}
//#endregion
